export default __webpack_public_path__ + "09f84f6035cfbf7c3984b6177d36b516.ttf";